"use client"

import type React from "react"
import { Toaster } from "sonner"

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Toaster
        position="top-right"
        richColors
        closeButton={true}
        toastOptions={{
          style: {
            background: "white",
            border: "1px solid #e2e8f0",
            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
          },
          duration: 5000,
        }}
      />
      {children}
    </>
  )
}
